// @ts-nocheck

export default {
	env: {
		name: "" || 'dev',
	},
	server: {
		authUserName: "riff" || 'riff',
		authPassword: "raff" || 'raff',
		baseUrl: "https://api5.tempstars.ca/" || 'https://api.dev.tempstars.ca/',
		socketIoUrl: "https://api5.tempstars.ca/" || 'https://api.dev.tempstars.ca/',
	},
	bucket: {
		baseUrl: "https://s3.amazonaws.com/tempstars.ca/" || 'https://s3.amazonaws.com/tempstars.ca/',
	},
	push: {
		senderID: "210360814619" || '210360814619',
	},
	stripe: {
		CA: {
			pubKey: "pk_live_tdijS4i5we1wFCYHo4thvW1j" || 'pk_test_yzhl7dmUrMvdEB9BaKuKhgpL',
		},
		US: {
			pubKey: "pk_live_51MQ87TGl9ao7V0nTpzwqrDmSnZjQDMw3XXXBRuGJZ9r8PPv5H3jOQZMhd6R7pM98LbEcGpzrlTLCVLfQaYCGbhrZ00uDGR8kXC" || 'pk_test_Zr5fHPeNtlFjsscMLDHTdsoA',
		},
	},
	loggly: {
		enabled: true || true,
		key: "7a96865b-dac0-4059-afcd-e08555fe10b3" || '7a96865b-dac0-4059-afcd-e08555fe10b3',
	},
	mixpanel: {
		enabled: true || false,
		token: "3e35ce85f7cf4ff6d2ccf868f22a8e04" || '399a45b6eea7aea3f7fb578e85cf9db6',
	},
	sendbird: {
		appId: "" || 'B2D6ED35-D3EA-4768-8F27-555762CE59FC',
		botId: "" || 'bKLrhORW_t_hhri8vIiEs',
	},
	web: {
		appUrl: "https://app.tempstars.com" || 'https://app.tempstars.net',
		CA: {
			siteUrl: "www.tempstars.ca" || 'www.tempstars.ca',
		},
		US: {
			siteUrl: "www.tempstars.com" || 'www.tempstarsapp.com',
		},
	},
	CA: {
		helpEmail: "help@tempstars.ca" || 'help@tempstars.com',
		tempAmount: "$57+hst" || '$38+hst',
		tokensLink: "" || 'http://www.tempstars.ca/tokens',
	},
	US: {
		helpEmail: "help@tempstars.com" || 'help@tempstarsapp.com',
		tempAmount: "$38" || '$25',
		tokensLink: "" || 'http://www.tempstarsapp.com/tokens',
	},
	debug: false || true,
	testMode: false || true,
}
